import type {
	JarabotLoginOffer,
	JarabotLoginOfferContext,
	JarabotLoginOfferEvaluator,
} from './types';

export function pickLoginOffer(
	evaluators: JarabotLoginOfferEvaluator[],
	context: JarabotLoginOfferContext,
	isCancelled: () => boolean = () => false
): Promise<JarabotLoginOffer | null> {
	return evaluators
		.reduce<Promise<JarabotLoginOffer | null>>(
			(previous, evaluate) =>
				previous.then((picked) => {
					if (picked || isCancelled()) return picked;
					// a failing offer must not block the lower-priority ones
					return evaluate(context).catch(() => null);
				}),
			Promise.resolve(null)
		)
		.then((offer) => (isCancelled() ? null : offer));
}
